<button pButton pRipple
        [label]="label"
        [loading]="loading"
        class="p-button-primary p-button-raised p-button-rounded w-full"
        (click)="continueClick.emit()">
</button>